var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixedgoBack"},[_c('div',{staticClass:"arrow__top",on:{"click":_vm.gotop}},[_c('img',{attrs:{"src":require("../../assets/arrowUp.svg"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }